import { eventBus } from "#bb/lib/eventBus";
import { isValidatableComponentId } from "#bb/lib/validation";

export function useGlobalBlockCommands(id: string) {
  /** Move the composable call inside the function */
  const { getContentById, updateContentById } = useContentManager();

  function getGlobalCommands(blockId: string, data?: any) {
    const block = getContentById(blockId);
    const commands: any[] = [
      {
        id: "edit-id",
        name: "Identifier",
        description: "Change the block identifier",
        icon: "lucide:fingerprint",
        action: () => {
          eventBus.emit(`component:onEditId:${blockId}`, {
            data: getContentById(blockId),
          });
        },
      },
      {
        id: "edit-raw",
        name: "Raw",
        description: "Change the JSON configuration",
        icon: "lucide:curly-braces",
        action: () => {
          eventBus.emit(`component:onEditRaw:${blockId}`, {
            data: getContentById(blockId),
          });
        },
      },
      {
        id: "edit-layout",
        name: "Layout",
        description: "Visibility and layout",
        icon: "lucide:layout-dashboard",
        action: () => {
          eventBus.emit(`component:onEditLayout:${blockId}`, {
            data: getContentById(blockId),
          });
        },
      },
      {
        id: "edit-conditions",
        name: "Rules",
        description: "Conditional rendering",
        icon: "lucide:book-check",
        action: () => {
          eventBus.emit(`component:onEditCondition:${blockId}`, {
            data: getContentById(blockId),
          });
        },
      },
    ];

    if (isValidatableComponentId(block?.componentId)) {
      commands.push({
        id: "edit-validation",
        name: "Validation",
        description: "Required, min/max, pattern and error messages",
        icon: "lucide:shield-check",
        action: () => {
          eventBus.emit(`component:onEditValidation:${blockId}`, {
            data: getContentById(blockId),
          });
        },
      });
    }

    return [
      {
        id: "global-group",
        type: "group",
        name: "Global",
        description: "Manage global settings",
        commands,
      },
    ];
  }

  function injectGlobalCommands(
    existingCommands: any[] = [],
    blockProps: { id: string; layout?: any }
  ) {
    const alreadyHasLayoutGroup = existingCommands.some(
      (group) => group.id === "layout-group"
    );
    if (alreadyHasLayoutGroup) {
      return existingCommands;
    }

    const layoutCommands = getGlobalCommands(blockProps.id, blockProps);
    return [...existingCommands, ...layoutCommands];
  }

  return {
    injectGlobalCommands,
  };
}
